module.exports = __webpack_public_path__ + "static/img/bg_circle.1aa708e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/bg_circle.svg
// module id = uqtK
// module chunks = 1